<template>
  <div class="photoinfobtn" v-show="!isSelecteAble">
<!--    <button @click.prevent="setEditPhotoIndex(true)" data-toggle="tooltip" data-placement="top" @click="editImage" title="Foto Bearbeiten" v-if="isMainView && usercan('editor')" type="button" class="btn btn-edit-photo shadow-sm">-->
    <button @click.prevent="setEditPhotoIndex" data-toggle="tooltip" data-placement="top" title="Foto Bearbeiten" v-if="isMainView && usercan('editor')" type="button" class="btn btn-edit-photo shadow-sm">
      <i class="fa fa-edit" aria-hidden="true"></i>
    </button>
    <button data-toggle="tooltip" data-placement="top" title="Foto herunterladen" @click="downloadPhoto()" v-if="isMainView" type="button" class="btn btn-download-photo shadow-sm" >
      <i class="fa fa-download" aria-hidden="true"></i>
    </button>
    <button type="button"
            @mouseenter="getInfo(photo, '', $event)"
            @click.prevent="setJumpPhotoIndex"
            class="btn btn-info-popup info-popup-hover shadow-sm"
            :class="{'rounded': !isMainView}">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
    </button>

    <div class="photoinfo shadow shadow-lg border" :class="[{'icons-bar': !isMainView}, 'infobox_'+photo.pdphotoid]"
    style="position:fixed"
         :style="{left: `${posx}px`, top: `${posy}px`}"
    >
      <table class="table">
        <tr>
          <td width="100"><strong>Foto Id:</strong></td>
          <td>{{photo.runid}}</td>
        </tr>
        <tr>
          <td><strong>Datum:</strong></td>
          <td>{{photo.photodateBydot}} {{photo.photodateBytime}}Uhr</td>
        </tr>
        <tr>
          <td><strong>Dateiname:</strong></td>
          <td>  {{photo.origname | LiveSubStr('15')}}</td>
        </tr>
        <tr class="sep">
          <td colspan="2"></td>
        </tr>
        <tr>
          <td><strong>Ersteller:</strong></td>
          <td> {{creator}} ({{photo.pduserid}})</td>
        </tr>
        <tr>
          <td><strong>Plan:</strong></td>
          <td> {{ planname}}</td>
        </tr>
        <tr class="sep">
          <td colspan="2"></td>
        </tr>
        <tr>
          <td><strong>Schlagworte:</strong></td>
          <td>
            <span class="tags" v-for="tag in  photo.params" >  {{tag.name}}  </span>
          </td>
        </tr>
        <tr class="sep">
          <td colspan="2"></td>
        </tr>
        <tr>
          <td colspan="2"><strong>Fotobeschreibung</strong>
            <p>{{photo.description}}</p>
          </td>
        </tr>
      </table>
    </div>
  </div>

</template>

<script>

import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import {mapState} from 'vuex'
export default {
  name: 'popupInfo',
  props: ['photo', 'isSelecteAble', 'taskModule', 'isEdit', 'index'],
  filters: {
    LiveSubStr: function(string, len) {
      if(string.length <= len) {
        return string
      }
      return string.substring(0,len) + '...';
    }
  },
  data () {
    return {
      getMemosUrl: process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photo/' + this.photo.id + '/getmemos',
      memos: '',
      planname: '',
      creator: '',
      tags: [],
      posx: 0,
      posy: 0
    }
  },
  async mounted () {
    // this.getDetails();
    //  this.getMemos();
    // this.getTags();
    // this.getUsers();
    // console.log('this.$store.state.appSettings.projectUsers', this.$store.state.appSettings.projectUsers)
    // if(this.$store.state.appSettings.projectUsers == []) {
    //   console.log('FetchProjectUsers')
    // }
    $('[data-toggle="tooltip"]').tooltip()
  },
  computed: {
    ...mapState({
      projectUsers: state => state.appSettings.projectUsers
    }),
    isMainView() {
      return this.$route.name === 'photo';
    },
  },

  watch: {
  },
  methods: {
    setEditPhotoIndex(){

      this.$store.commit('setIsEditPhoto', true)
      this.$store.commit('setEditPhoto', this.index)

      this.$store.state.photo.isEdit = true


      if(!this.$store.state.photo.isDetailView) {
        this.$store.commit('setDetailsView')
      }
      console.log('isEdit EditPhoto to', true)
    },
    setJumpPhotoIndex(){

      this.$store.commit('setIsEditPhoto', false)
      this.$store.commit('setEditPhoto', this.index)


      if(this.$store.state.photo.isDetailView) {
        this.$store.state.photo.isEdit = false
      }

      if(!this.$store.state.photo.isDetailView) {
        this.$store.commit('setDetailsView')
      }
      console.log('isEdit JumpToPhoto to', true)
    },
    // editImage() {
    //   this.$emit('setSliderImages')
    // },
    async downloadPhoto() {
      const url = process.env.VUE_APP_GET_METHOD_URL + "img&projectid=" + this.photo.projectid + "&type=orig&id=" + this.photo.pdphotoid + `&token=` + localStorage.sessiontoken
      const filename = this.photo.origname
      this.$toast.success('Dateidownload gestartet')
      await fetch(url, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
        }
      }).then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, filename)
        })
    },




    // async getUsers() {
    //   await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getUsers&token=` + localStorage.sessiontoken, {
    //     "methodName": "getUsersOfProject",
    //     "serviceName": "ProjectdocuService",
    //     "parameters": [
    //       this.$route.params.id
    //     ]
    //   }, {
    //     headers: {
    //       apitoken: localStorage.apikey,
    //       deviceid: localStorage.deviceid,
    //       accept: 'application/json'
    //     }
    //   })
    //     .then(response => {
    //       if (response.status == 200) {
    //         this.creators = response.data
    //       }
    //     })
    //     .catch(error => console.log(error))
    //     .finally(() => {
    //       $('.spinner-cover').hide()
    //     })
    // },

    async getDetails (photo) {

      let _this = this
      let id = photo.pdphotoid
      let pduserid = photo.pduserid
      this.creators = _this.projectUsers

      // let url = process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photo/' + id + '/getdetails'
      let params = {
        "methodName": "getPlansOfPhoto",
        "parameters": [id],
        "serviceName": "ProjectdocuService"
      }
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getPlansOfPhoto&token=` + localStorage.sessiontoken, params, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(response => {
          if (response.status === 200) {
            let planname = ''
            if(response.data.plans.length >= 1) {
              response.data.plans.forEach(function(value, i) {
                if(i > 0) {
                  planname = planname + ', '
                }
                planname = value.description ? value.description : value.origname
              })
              this.planname = planname
            } else {
              this.planname = 'Kein Plan'
            }



            _this.creator = 'unbekannt';
            this.creators.forEach(function(value, idx) {
              if(pduserid == value.pduserid) {
                _this.creator = value.firstname + ' ' + value.lastname
              }
            })

            this.creator = _this.creator

            // this.planname = response.data.plans[0] ? response.data.plans[0].description : 'No Plan'
            // _this.tags = []
            // response.data.data.tags.forEach(function (value, i) {
            //   _this.$store.state.photo.tags.forEach(function (value1, i1) {
            //     if (value1.id === value.tag_id) {
            //       _this.tags.push(value1.title)
            //     }
            //     value1.childs.forEach(function (value2, i2) {
            //       if (value2.id === value.tag_id) {
            //         _this.tags.push(value2.title)
            //       }
            //     })
            //   })
            // })
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })

        // await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getUserWithUserID&token=` + localStorage.sessiontoken,
        //   {
        //     "methodName": "getUserWithUserID",
        //     "parameters": [userid],
        //     "serviceName": "ProjectdocuService"
        //   }
        //   , {
        //   headers: {
        //     apitoken: localStorage.apikey,
        //     deviceid: localStorage.deviceid,
        //     accept: 'application/json'
        //   }
        // })
        // .then(response => {
        //   if (response.status === 200) {
        //
        //     console.log('userdata', response.data)
        //
        //     // let planname = ''
        //     // if(response.data.plans.length >= 1) {
        //     //   response.data.plans.forEach(function(value, i) {
        //     //     if(i > 0) {
        //     //       planname = planname + ', '
        //     //     }
        //     //
        //     //     planname = value.description ? value.description : value.origname
        //     //   })
        //     //   this.planname = planname
        //     // } else {
        //     //   this.planname = 'Kein Plan'
        //     // }
        //     // // this.planname = response.data.plans[0] ? response.data.plans[0].description : 'No Plan'
        //     // // _this.tags = []
        //     // // response.data.data.tags.forEach(function (value, i) {
        //     // //   _this.$store.state.photo.tags.forEach(function (value1, i1) {
        //     // //     if (value1.id === value.tag_id) {
        //     // //       _this.tags.push(value1.title)
        //     // //     }
        //     // //     value1.childs.forEach(function (value2, i2) {
        //     // //       if (value2.id === value.tag_id) {
        //     // //         _this.tags.push(value2.title)
        //     // //       }
        //     // //     })
        //     // //   })
        //     // // })
        //   }
        // })
        // .catch(error => console.log(error))
        // .finally(() => {
        //   $('.spinner-cover').hide()
        // })
    },
     getTags () {
      axios.get(this.getTagsUrl, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        })
        .then(response => {
          if (response.status === 200) {

          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })
    },

    getInfo (id, pduserid, event) {
      this.getDetails(id, pduserid);
      this.posx = event.clientX;
      this.posy = event.clientY;

      if(event.screenX <= 400) {
        $('.photoinfobtn').addClass('show_infobox_right')
      } else {
        $('.photoinfobtn').removeClass('show_infobox_right')
      }

      if(this.$store.state.photo.opennav.mySidenav <= 0) {
        if(event.x <= 500) {
          $('.photoinfobtn').addClass('show_infobox_right')
        } else {
          $('.photoinfobtn').removeClass('show_infobox_right')
        }
      }

      if((event.y + 300) >= $('body').outerHeight()) {
        $('.photoinfobtn').addClass('show_infobox_top')
      } else {
        $('.photoinfobtn').removeClass('show_infobox_top')
      }

      let screenheight = $(window).height();
      let boxHeight = $('.infobox_' + id.pdphotoid + ' .table').outerHeight() + 50;
      if(this.posy + boxHeight >= screenheight) {
        this.posy = screenheight - (boxHeight + 50);
      }

      if (this.taskModule) {
        if(event.x <= 1200) {
          $('.photoinfobtn').addClass('show_infobox_right')
        } else {
          $('.photoinfobtn').removeClass('show_infobox_right')
        }
      }
    },

     getMemos () {
      axios.get(this.getMemosUrl, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: 'string',
            accept: 'application/json'
          }
        })
        .then(response => {
          if (response.status === 200) {

          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })
    }
  }
}


</script>
<style scoped>
.photoinfobtn button.btn{
  z-index: 99;
  position: relative;
  padding-inline: 6px;
  padding-block: 4px;
  background-color: #e4e4e4cc;
  margin: 0;
  line-height: 1;
  color: #464343;
  float: left;
  border-radius: 0;
  font-size: 18px;
  top: 3px;
}
.photoinfobtn button.btn:hover{
  background-color: rgba(211, 211, 211, 0.8);
}
.photoinfobtn button.btn-info-popup{
 border-top-right-radius: 4px;
 border-bottom-right-radius: 4px;
}
.photoinfobtn button.btn-edit-photo{
 border-top-left-radius: 4px;
 border-bottom-left-radius: 4px;
}
.photoinfobtn button.btn-download-photo.rounded {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 0;
}
.photoinfobtn button:first-child {
  border-radius: 4px 0 0 4px;
}
.photoinfobtn button:last-child {
  border-radius: 0 4px 4px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/photo/components/infoPopup.vue